<template lang="pug">

	div#artworksGrid.text-red.h-full
		.filterOverlay.fixed.inset-0.z-40.cursor-pointer.backdrop-filter(v-if="filters.open" @click="toggleFilter()")
		.loadingScreen.fixed.inset-0.flex.bg-opacity-50.justify-center.items-center.bg-white.z-40.cursor-pointer(v-if="loading")
			i.fas.fa-asterisk.fa-spin.text-lg
		.artworks-filter-nav.default-grid-no-gap.relative.z-40.sticky(:style='{backgroundColor : bgcolor, top : navHeight}' class="md:border-red md:border-t md:border-b")
			.col-span-1.border-r.border-red.border-t(class="mobile:hidden")
			.col-span-13.border.border-red(class="md:border-b-0 md:col-span-8 mobile:border-t-0 mobile:border-l-0")
				.filter.py-025.cursor-pointer.relative
					.filter-arrow.absolute.top-0.right-0.bottom-0.px-1.flex.items-center.pointer-events-none
						i.fal.fa-chevron-down.text-medium.pointer(v-bind:class="{ 'fa-chevron-up' : filters.mediums.active }")
					.filter-title(@click="toggleFilter('mediums')") Medium:
					template(v-if="filters.mediums.filter")
						.filter-selected.text-blue(@click="filterArtworks('mediums', '')" class="hover:line-through") {{ filters.mediums.filter }} &times;
					template(v-else)
						.filter-selected.text-blue(@click="toggleFilter('mediums')") All
					.filter-items(v-bind:class="{'active' : filters.mediums.active}")
						.filter-item(
							v-for="item in taxonomies.mediums"
							@click="filterArtworks('mediums', item.slug)"
							v-bind:class="{'text-blue line-through' : filters.mediums.filter === item.slug}"
							class="hover:text-blue"
						) {{ item.title }}
			.col-span-13.border.border-red(class="md:border-b-0 md:col-span-8 mobile:border-t-0 mobile:border-r-0")
				.filter.py-025.cursor-pointer.relative
					.filter-arrow.absolute.top-0.right-0.bottom-0.px-1.flex.items-center.pointer-events-none
						i.fal.fa-chevron-down.text-medium.pointer(v-bind:class="{ 'fa-chevron-up' : filters.categories.active }")
					.filter-title(@click="toggleFilter('categories')") Category:
					template(v-if="filters.categories.filter")
						.filter-selected.text-blue(@click="filterArtworks('categories', '')" class="hover:line-through") {{ filters.categories.filter }} &times;
					template(v-else)
						.filter-selected.text-blue(@click="toggleFilter('categories')") All
					.filter-items(v-bind:class="{'active' : filters.categories.active}" class="mobile:transform mobile:-translate-x-1/2")
						.filter-item(
							v-for="item in taxonomies.categories"
							@click="filterArtworks('categories', item.slug)"
							v-bind:class="{'text-blue line-through' : filters.categories.filter === item.slug}"
							class="hover:text-blue"
						) {{ item.title }}
			.col-span-full.border.border-red.border-b-0.px-1.py-025(class="md:col-span-8 mobile:border-l-0 mobile:border-r-0 mobile:hidden")
				div Search:
				template(v-if="!search.active")
					form(v-on:submit.prevent="searchArtworks()")
						input.w-full.uppercase.rounded-none.appearance-none.bg-transparent(type="text" :placeholder="searchPlaceholders" name="q" v-model="search.query" ref="search-input")
						button.invisible
				template(v-else)
					div.text-blue.border-b.border-transparent.cursor-pointer(@click="searchArtworks(true)" class="hover:line-through") {{ search.query }} &times;
			.col-span-1.border-l.border-red.border-t(class="mobile:hidden")

		.default-grid-no-gap.relative.z-20.h-full
			.col-span-1.border-r.border-red.border-b-2.border-t(class="mobile:hidden")
			template(v-if="artworks && artworks.length")
				.artwork-grid-no-gap.relative.z-20.border-b.border-red.col-span-full(class="md:col-span-24")
					template(v-for="item in artworks")
						a.block.artwork-grid-item.col-span-full.border.border-red.flex.flex-col.justify-between.bg-contain.bg-center(
							:href="item.url"
							class="md:col-span-8 mobile:border-l-0 mobile:border-r-0"
							:style="setBackgroundImage(item)"
							style="background-size: 170%"
						)
							div.image
							.artwork-grid-content.p-1.text-sm(:style="{ color: item.text_color_override }")
								p "{{ item.title }}"
								p {{ item.type }} H:&nbsp;{{ item.height }}&nbsp;W:&nbsp;{{ item.width }} &copy;{{ item.year }}
			template(v-else)
				.col-span-full.text-center.py-8.border.border-b-2(class="md:col-span-24")
					p(v-if="searchResults") No " {{ filters.categories.filter }} {{ filters.mediums.filter }} {{ search.query }} " Yet
					p(v-if="searchResults" @click="filterArtworks()" class="hover:line-through").cursor-pointer.text-blue.pt-2 Try Again
			.col-span-1.border-l.border-red.border-b-2.border-t(class="mobile:hidden")

</template>

<script>
window.axios = require("axios").default;
let token = document.head.querySelector('meta[name="csrf-token"]');

import imagesLoaded from "vue-images-loaded";

export default {
	name: "Artworks",
	data() {
		return {
			color: null,
			bgcolor: null,
			loading: true,
			artworks: null,
			taxonomies: {
				categories: null,
				mediums: null,
			},
			search: {
				active: false,
				query: "",
				placeholders: ["test", "two", "three"],
			},
			filters: {
				open: false,
				categories: {
					active: false,
					filter: "",
				},
				mediums: {
					active: false,
					filter: "",
				},
			},
		};
	},
	computed: {
		searchResults() {
			if (
				this.filters.categories.filter ||
				this.filters.mediums.filter ||
				this.search.query
			) {
				return true;
			} else {
				return false;
			}
		},
		navHeight() {
			return (
				document.getElementsByClassName("nav")[0].offsetHeight + "px"
			);
		},
		searchPlaceholders() {
			// let test
			// setTimeout(function(){
			// 	const random = Math.floor(Math.random() * this.search.placeholders.length);
			// 	test = this.search.placeholders[random]
			// }, 700)
			// return test
		},
	},
	methods: {
		setBackgroundImage(item) {

			let desktopImageUrl =
				item.image.length > 0
					? "/img/" + item.image[0].url + "?w=1300"
					: "";
					
			// Check if mobile override exists and has images
			let mobileImageUrl = 
				item.images_mobile_override && item.images_mobile_override.length > 0
					? "/img/" + item.images_mobile_override[0].url + "?w=1300"
					: desktopImageUrl; // Fall back to desktop image if no mobile override
			
			// Escape parentheses for both URLs
			desktopImageUrl = desktopImageUrl.replace(/([()])/g, "\\$1");
			mobileImageUrl = mobileImageUrl.replace(/([()])/g, "\\$1");

			// Store both URLs as data attributes that can be accessed by CSS
			return {
				backgroundImage: `url(${desktopImageUrl})`,
				'--desktop-bg-image': `url(${desktopImageUrl})`,
				'--mobile-bg-image': `url(${mobileImageUrl})`,
				'--has-mobile-image': mobileImageUrl !== desktopImageUrl ? '1' : '0'
			};
		},
		toggleFilter(taxonomy) {
			switch (taxonomy) {
				case "categories":
					this.filters.categories.active =
						!this.filters.categories.active;
					break;
				case "mediums":
					this.filters.mediums.active = !this.filters.mediums.active;
					break;
				default:
					this.filters.categories.active = false;
					this.filters.mediums.active = false;
			}

			if (this.filters.categories.active || this.filters.mediums.active) {
				this.filters.open = true;
			} else {
				this.filters.open = false;
			}
		},
		filterArtworks(taxonomy, item) {
			console.log("Filtering: " + taxonomy + " by: " + item);
			switch (taxonomy) {
				case "categories":
					this.filters.categories.filter = item;
					this.filters.categories.active = false;
					this.filters.open = false;
					break;
				case "mediums":
					this.filters.mediums.filter = item;
					this.filters.mediums.active = false;
					this.filters.open = false;
					break;
				default:
					this.filters.categories.filter = "";
					this.filters.mediums.filter = "";
					this.search.query = "";
					this.search.active = false;
			}
			this.getArtworks();
		},
		searchArtworks(clear) {
			console.log("Searching?");
			if (clear) {
				this.search.active = false;
				this.search.query = "";
			} else {
				this.search.active = true;
			}
			this.getArtworks();
		},
		getArtworks() {
			console.log("Fetching Artworks");
			this.loading = true;
			axios({
				url: "/graphql",
				method: "post",
				headers: {
					"X-CSRF-TOKEN": token.content,
				},
				data: {
					query:
						`
						query getArtworks {
							entries(collection: "artworks",
								sort: "order",
								filter: {
									title: {contains: "` +
						this.search.query +
						`"},
									categories: {contains: "` +
						this.filters.categories.filter +
						`"},
									mediums: {contains: "` +
						this.filters.mediums.filter +
						`"}
								}) {
								data {
									... on Entry_Artworks_Artworks {
										id
										title
										sku_id
										url
										type
										year
										width
										height
										text_color_override
										image {
											url
										}
										images_mobile_override {
											url
										}
										categories {
											title
											slug
										}
										mediums {
											title
											slug
										}
									}
								}
							}
							categories: terms(taxonomy: "categories") {
								data {
									slug
									title
								}
							}
							mediums: terms(taxonomy: "mediums") {
								data {
									slug
									title
								}
							}
							page: entry(collection: "pages", slug: "artworks") {
								... on Entry_Pages_Pages {
								id
								bg_colour
								text_colour
								}
							}
						}
					`,
				},
			})
				.then((response) => {
					console.log("Artworks Fetched...", response);
					this.bgcolor = response.data.data.page.bg_colour;
					this.color = response.data.data.page.text_colour;
					this.artworks = response.data.data.entries.data;
					this.taxonomies.categories =
						response.data.data.categories.data;
					this.taxonomies.mediums = response.data.data.mediums.data;
				})
				.catch((error) => {
					console.log("Something went wrong Yo...", error);
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
	mounted: function () {
		console.log("Artworks App Mounted...");
		this.getArtworks();
	},
	directives: {
		imagesLoaded,
	},
};
</script>

<style scoped>
/* Add responsive background image switching for mobile devices */
@media (max-width: 768px) {
	.artwork-grid-item[style*="--has-mobile-image: 1"] {
		background-image: var(--mobile-bg-image) !important;
		background-size: 100% !important;
	}
}
</style>
